import styled from "styled-components";

const Container = styled.div`
  width: fit-content;
  max-width: 460px;
  height: auto;
  margin: 24px 40px;
  border: 0;
  padding: 24px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 16px;
  box-shadow: 0 8px 20px #1e1d2a;
  background-color: ${(props) => props.theme.color.background.primary};
  overflow-y: auto;
  max-height: 95%;
  top: 0;
  position: absolute;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px transparent;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    margin: 16px;
  }
  :hover {
    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: ${(props) => props.theme.color.background.light};
    }
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-border-radius: 4px;
      border-radius: 4px;
      margin: 16px;
    }
  }
`;

const Close = styled.img`
  position: absolute;
  display: inline-block;
  size: auto;
  top: 24px;
  right: 14px;
  padding: 8px;
  cursor: pointer;
  &:hover {
    opacity: 90%;
  }
`;

const MobileViewClose = styled.img`
  position: absolute;
  display: inline-block;
  size: auto;
  top: 2px;
  right: 20px;
  cursor: pointer;
  &:hover {
    opacity: 90%;
  }
`;

export { Container, Close, MobileViewClose };
